import { render, staticRenderFns } from "./AcademyActivitiesLayout.vue?vue&type=template&id=456b7e97&scoped=true"
import script from "./AcademyActivitiesLayout.vue?vue&type=script&lang=js"
export * from "./AcademyActivitiesLayout.vue?vue&type=script&lang=js"
import style0 from "./AcademyActivitiesLayout.vue?vue&type=style&index=0&id=456b7e97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456b7e97",
  null
  
)

export default component.exports